export const getErrorMessage = (error) =>
  error?.extensions?.message || 'Failed to Get Data';

/**
 * Guest flow base path constant
 */
export const GUEST_FLOW_BASE_PATH = '/guest-plan-selection';

/**
 * Checks if the current page is part of the guest flow
 * @returns true if user is in guest flow, false otherwise
 */
export const isGuestFlow = (): boolean =>
  window.location.pathname.includes(GUEST_FLOW_BASE_PATH);
